import { useEffect } from "react";
import { useMap } from "react-map-gl";
import openRoads from "../../../../static/openroads-icon.webp";

export function useOpenRoadsIconLoader()
{
    const { current: map } = useMap();

    useEffect( () =>
    {
        const mapInstance = map?.getMap?.();
        if ( !mapInstance || mapInstance.hasImage( "openRoadsIcon" ) ) return;

        mapInstance.loadImage( openRoads, ( err, image ) =>
        {
            if ( err || !image ) return;
            if ( !mapInstance.hasImage( "openRoadsIcon" ) )
            {
                mapInstance.addImage( "openRoadsIcon", image );
            }
        } );
    }, [ map ] );
}
